import { map, concatMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ofType } from 'redux-observable';
import { Action } from '../app/basicModels';
import { ErrorMsg } from '../../settings/models/Error';
import { notification } from '../../components';
import actions from './actions';
import { notifyThresholdError } from './errors';
import { CreateThresholdBody, SaveThresholdPayload } from './models';
import { createThreshold, deleteThreshold, getThresholds, updateThreshold } from './service';

export const handleLoadThresholds = action$ =>
  action$.pipe(
    ofType(actions.LOAD_THRESHOLDS),
    concatMap(() =>
      getThresholds().pipe(
        map(response => actions.loadThresholdsSuccess(response.data?.content ?? [])),
        catchError((error: ErrorMsg) => of(actions.loadThresholdsFailure(notifyThresholdError(error, 'Error loading thresholds!'))))
      )
    )
  );

export const handleSaveThreshold = action$ =>
  action$.pipe(
    ofType(actions.SAVE_THRESHOLD),
    map((action: Action<SaveThresholdPayload>) => action.payload),
    concatMap(({ id, body }: SaveThresholdPayload) => {
      const request$ = id ? updateThreshold(id, body) : createThreshold(body as CreateThresholdBody);
      return request$.pipe(
        concatMap(() => {
          notification('success', id ? 'Threshold updated!' : 'Threshold created!');
          // Refetch the full list so the table reflects the change immediately.
          return of(actions.saveThresholdSuccess(), actions.loadThresholds());
        }),
        catchError((error: ErrorMsg) => of(actions.saveThresholdFailure(notifyThresholdError(error, 'Error saving threshold!'))))
      );
    })
  );

export const handleDeleteThreshold = action$ =>
  action$.pipe(
    ofType(actions.DELETE_THRESHOLD),
    map((action: Action<string>) => action.payload),
    concatMap((id: string) =>
      deleteThreshold(id).pipe(
        concatMap(() => {
          notification('success', 'Threshold deleted!');
          return of(actions.deleteThresholdSuccess(), actions.loadThresholds());
        }),
        catchError((error: ErrorMsg) => of(actions.deleteThresholdFailure(notifyThresholdError(error, 'Error deleting threshold!'))))
      )
    )
  );
